module.exports = __webpack_public_path__ + "img/shopping_cart_white_18dp.5dbcfe56.svg";